import * as React from "react";
import { Selectors, useAvailableOptIns, useOptIns } from "@grandvisionhq/auth";
import { useIntl, useSelector, useDispatch, useFeatureToggles } from "@grandvisionhq/state";
import { setChangedOptIns } from "../../../../../../actions.js";
import { getConsents, shouldCreateAccount } from "../../../../../../selectors.js";
import { toggleConsent, setConsents } from "../../../../../../StepShipping/StepShipping/actions.js";
import { ConsentsContainer } from "../../../../containers/modules/Consents/containers/ConsentsContainer.js";
import { CreateAccountContainer } from "../../../../containers/modules/Consents/containers/CreateAccountContainer.js";
import { OptInsContainer } from "../../../../containers/modules/Consents/containers/OptInsContainer.js";
import { toSavedOptIns, getShownOptIns, toChangedOptIns } from "../../../../utils/modules/Consents/utils/opt-ins.js";
import { useCheckoutSettings } from "../../../../../../context/CheckoutSettings/context/CheckoutSettings/context.js";
const Consents = ({ handleOptInsLoading }) => {
  const { getLabel } = useIntl();
  const { consent: consentSettings, account } = useCheckoutSettings();
  const consents = useSelector(getConsents);
  const dispatch = useDispatch();
  const isLoggedIn = useSelector(Selectors.isLoggedIn);
  const { availableOptIns } = useAvailableOptIns();
  const { optInsFromServer, isFetching } = useOptIns();
  const isCreateAccountEnabled = useSelector(shouldCreateAccount);
  const { isMyAccountEnabled } = useFeatureToggles();
  const selectedConsents = React.useMemo(
    () => consents?.filter((consent) => consent.isChecked),
    [consents]
  );
  const handleConsentChange = React.useCallback(
    (selectedConsents2) => {
      dispatch(toggleConsent({ consents: selectedConsents2.map((consent) => consent.value) }));
    },
    [dispatch]
  );
  React.useEffect(() => {
    const checkoutConsents = consentSettings?.items || [];
    if (checkoutConsents.length !== consents?.length) {
      const initialConsents = checkoutConsents.map((consent) => ({
        ...consent,
        isChecked: false
      }));
      dispatch(setConsents({ consents: initialConsents }));
    }
  }, [consentSettings, consents]);
  const [selectedOptIns, setSelectedOptIns] = React.useState([]);
  const allOptIns = consentSettings?.optIns || availableOptIns.filter((item) => item.isInSignup);
  const savedOptIns = React.useMemo(() => toSavedOptIns(optInsFromServer), [optInsFromServer]);
  const shownOptIns = React.useMemo(
    () => getShownOptIns(allOptIns, savedOptIns),
    [allOptIns, savedOptIns]
  );
  const handleOptInsChange = React.useCallback(
    (selectedItems) => {
      setSelectedOptIns(selectedItems);
      const changedOptIns = toChangedOptIns(allOptIns, savedOptIns, selectedItems, getLabel);
      dispatch(setChangedOptIns(changedOptIns));
    },
    [dispatch, getLabel, allOptIns, savedOptIns]
  );
  React.useEffect(() => {
    handleOptInsLoading?.({ isOptInsLoading: isFetching });
  }, [isFetching]);
  return /* @__PURE__ */ React.createElement("div", { className: "checkout__checkboxes" }, /* @__PURE__ */ React.createElement(CreateAccountContainer, null), /* @__PURE__ */ React.createElement(
    OptInsContainer,
    {
      optIns: shownOptIns,
      selectedOptIns,
      onChange: handleOptInsChange,
      isLoggedIn,
      isCreateAccountEnabled,
      isImplicitAccountCreation: account?.implicitAccountCreation,
      isMyAccountEnabled
    }
  ), /* @__PURE__ */ React.createElement(
    ConsentsContainer,
    {
      consents,
      selectedConsents,
      onChange: handleConsentChange
    }
  ));
};
export {
  Consents
};
//# sourceMappingURL=Consents.js.map
